export default {
  props: {
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case 'small':
          return 'beta-size__small';
        default:
          return 'beta-size__default';
      }
    },
  },
};
